import { thumnail } from "../assets/base64/thumnail";
import { videoFiles } from "../assets/base64/videoFiles";
import { avatarThumbnail } from "../assets/base64/avatarThumbail";

const Resources = {
    THUMBNAIL: `data:image/png;base64, ${thumnail}`,
    VIDEO_FILES: `data:image/png;base64, ${videoFiles}`,
    IMG_THUMBNAIL: require("../assets/images/thumbnail.png"),
    AVATAR_THUMBNAIL: `data:image/png;base64, ${avatarThumbnail}`,
}

export default Resources;